import * as utils from './utils'
import * as scroll from './scroll'
import * as typeOf from './typeof'
import * as lzString from './lzString'

export default {
  ...utils,             // 工具类
  ...scroll,            // 滚动条类
  ...typeOf,            // 判断类型
  ...lzString           // 压缩字符串
}



// WEBPACK FOOTER //
// ./src/assets/utils/index.js